import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppSignInPage } from './SignInPage';

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [AppSignInPage],
});
